import React from 'react';
import { HOME_MOVES_REWARDS } from '@/src/constants/analytics-subjects';
import { AnalyticsClick } from '@ovotech/ui-tools';
import { AnalyticsPotentialClickButton } from './styles';

export const AnalyticsPotentialClick = ({
  customLabel,
}: {
  customLabel: string;
}) => {
  return (
    <AnalyticsClick
      name={HOME_MOVES_REWARDS}
      properties={{
        customLabel,
      }}
    >
      <AnalyticsPotentialClickButton aria-hidden="true" />
    </AnalyticsClick>
  );
};
